The description type.

Currently, three identifiers are defined:

- `AdvertisementDetails` is the detailed description of the position that appears on the job ad.

- `SearchBulletPoint` is a highlight or selling point of the position that appears in search results.
  The number of bullet points that a job can provide is based on the `AdvertisementProductFeatures`'s `searchBulletPoints.limit`.
  The length limit applies to each search bullet point separately.

- `SearchSummary` is a short description that appears in search results.

Scheme requirements:

- The `seekAnz` scheme requires `AdvertisementDetails` and `SearchSummary` to be included.
